// extracted by mini-css-extract-plugin
module.exports = {"currency":"_2nZAQf-1zxOv","wrapper":"SuK45qOx_8WS","list":"_32FXVgocTwTI","list__item":"yWIPkGTsQaoD"};